// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"170":"49ffbf17","197":"5df77683","319":"2f5c4260","453":"3f038b64","612":"45b4100d","781":"2ff5c0a5","849":"cb3d28e5","908":"eadfc6d6"}[chunkId] + ".chunk.js";
};